import { splitProps } from "solid-js";
import { IconProps } from "~/types/icon";

export default function MagnifyingGlassIcon(props: IconProps) {
  const [local, others] = splitProps(props, ["class", "classList"]);

  return (
    <svg
      class={local.class}
      classList={local.classList}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...others}
    >
      <path
        d="M21 21L15.8033 15.8033M15.8033 15.8033C17.1605 14.4461 18 12.5711 18 10.5C18 6.35786 14.6421 3 10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18C12.5711 18 14.4461 17.1605 15.8033 15.8033Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
